import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NSUTPermitConstants } from '@ruby/configs/unit-train-permit.constants';
import { IUTPermitComment } from '@ruby/modules/unit-train/models/unit-train-permit.interface';

@Component({
  selector: 'ng-permit-comments-dialog',
  styleUrls: ['./permit-comments.dialog.scss'],
  templateUrl: './permit-comments.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitCommentsDialogComponent {
  @Input() title = 'Comments';
  @Input() comments: Array<IUTPermitComment> = [];
  @Input() loading!: boolean;
  gridConfigurations = NSUTPermitConstants.commentsGridConfigs;

  constructor() {}
}
